import { Injectable, inject } from '@angular/core';
import { FeedbackRequestBodyDTO, FeedbackResponseDTO } from '../dto/common-dto';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

/**
 * This service is responsible for sending the feedback (making a POST request).
 */
@Injectable({ providedIn: 'root' })
export class FeedbackService {
  // Inject HttpClient.
  private readonly http = inject(HttpClient);

  // Stores the API URL.
  private readonly API_URL = 'https://statusapi-test.vitec-mv.com/api/Status';

  /**
   * Sends the feedback.
   *
   * @param body Represents the feedback body.
   *
   * @returns An observable of the feedback response.
   */
  sendFeedback(body: FeedbackRequestBodyDTO): Observable<FeedbackResponseDTO> {
    return this.http.post<FeedbackResponseDTO>(this.API_URL, body);
  }
}
